import React from 'react';

import MrInputText from '../input-text/input-text';

const MrInputPassword = props => {
  return <MrInputText type="password" {...props} />;
};

export default MrInputPassword;
